import { render, staticRenderFns } from "./adv.vue?vue&type=template&id=480a8380"
import script from "./adv.vue?vue&type=script&lang=js"
export * from "./adv.vue?vue&type=script&lang=js"
import style0 from "./adv.vue?vue&type=style&index=0&id=480a8380&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports